/* eslint-disable */
<template>
	<div>
		<b-modal 
			id="modal-info" 
			centered 
			content-class="shadow" 
			@hidden="clean"
			:hide-footer="isExternal"
			:no-close-on-backdrop="mobile_version">
			<template v-slot:modal-header="{ close }" class="modal-header">
				<h5 class="modal-title" >
					{{ rental.title }} 
						<b-badge :class="rental.class">{{ badgeLabel }}
						
					<button v-if="!isExternal" @click="onShowAdh">+</button></b-badge>
					
				</h5>
				<button type="button" aria-label="Close" class="close" @click="close()">×</button>
			</template>	
			<!--
			<p><b>Durée d'utilisation</b> : {{(new Date((rental.time_use * 1000) -3600000)) | moment("HH:mm:ss") }}</p>
			-->
			<!--TODO passer les dates récupérées en UTC-->
			<div v-if="rental.start_val || rental.end_val"><!--"rental.status & 0x02"-->
				<p style="white-space: pre-wrap"><b>Date de début</b> : {{ rental.start | moment("dddd D MMMM HH:mm") }}<b>&#9;&#9;&#9;Valeur</b> : {{rental.start_val}}</p>
				<p v-if="!(rental.status & 0x04)" style="white-space: pre-wrap"><b>Date de fin</b> : {{ rental.end | moment("dddd D MMMM HH:mm") }}<b>&#9;&#9;&#9;Valeur</b> : {{rental.end_val}}</p>
			</div>
			<div v-else>
				<p><b>Date de début</b> : {{ rental.start | moment("dddd D MMMM HH:mm") }}</p>
				<p><b>Date de fin</b> : {{ rental.end | moment("dddd D MMMM HH:mm") }}</p>
			</div>
			<div v-if="!isExternal">
				<p><b>Code adhérent :</b> {{ rental.code }}</p>
				<!--On fait deux bloc plutot que des if imbriqué car le rendu visuel est différent sinon-->
				<p v-if="rental.cumul_terrain_converted != null && !rental.readOnly">
					<b>Cumul d'activité :</b> {{parseFloat((rental.cumul_terrain_converted*10).toFixed(0))/10}} {{rental.unit_title_label}}
					<b-button class="ml-2" size="sm" variant="info" @click="onRefresh" v-if="(isDefault || isValid || isREAL) && !isRefreshBusy" :disabled="isDeleteBusy">Rafraichir</b-button>
					<b-button  size="sm" variant="info" disabled v-if="isRefreshBusy"><b-spinner small></b-spinner> Rafraîchissement...</b-button>
				</p>
				<div>
					<p v-if="rental.unit_title != 10 && rental.unit_title != 4">
						<b>Durée d'utilisation</b> : {{parseFloat((rental.time_use/360).toFixed(0))/10 + " heures"}}
					</p>
					<b-button v-if="(typeof rental.geolocation_points !== 'undefined') && rental.geolocation_points.length > 0" class="ml-2" size="sm" variant="info" @click="map1_modal_open" :disabled='rental.geolocation_points=="None"'>
						<i class="ti-map-alt"></i>
						AFficher Localisation
					</b-button>
				</div>		
				<p v-if="rental.cumul_terrain_converted != null && rental.readOnly">
					<b>Cumul d'activité :</b> {{parseFloat((rental.cumul_terrain_converted*10).toFixed(0))/10}} {{rental.unit_title_label}}
				</p>
				<p v-if="rental.time_use != 0 && rental.unit_title != 10 && rental.unit_title != 4 && rental.cumul_terrain_converted != 0">
					<b>Vitesse moyenne :</b> {{parseFloat(((rental.cumul_terrain_converted/rental.time_use)*360000).toFixed(0))/100}}  {{rental.unit_title_label}}/h
				</p>
				<p v-if="rental.time_use != 0 && rental.unit_title != 10 && rental.unit_title != 4 && rental.cumul_terrain_converted == 0 && rental.cumul_terrain != 0">
					<b>Vitesse moyenne :</b> {{parseFloat(((rental.cumul_terrain/rental.time_use)*360000).toFixed(0))/100}}  u/h
				</p>
				<p v-if="rental.time_use != 0 && rental.unit_title == 4 && rental.cumul_terrain != 0">
					<b>Vitesse moyenne :</b> {{parseFloat(((rental.cumul_terrain/rental.time_use)*360000).toFixed(0))/100}} u/h
				</p>
				<p v-if="rental.time_use != 0 && rental.unit_title == 10 && rental.cumul_terrain_converted != 0">
					<b>Utilisation sur la période :</b> {{parseFloat(((rental.cumul_terrain_converted/(rental.time_use/3600))).toFixed(0))*100}} %
				</p>
				<p v-if="rental.cumul_valid != null"><b>Cumul d'activité validé :</b> {{parseFloat((rental.cumul_valid*10).toFixed(0))/10}} {{rental.unit_title_label}}</p>

				<p v-if="rental.activity" class="text-break">
					<b>Activité</b> : {{ rental.activity }}
					<b-button class="ml-2" size="sm" variant="info" @click="stopCurrentRental" v-if="rental.status & 0x04" :disabled="isDeleteBusy">Terminer</b-button>
					<b-button class="ml-2" size="sm" variant="danger" @click="deleteCurrentRental" v-if="rental.status & 0x04" :disabled="isDeleteBusy">Supprimer</b-button>
				</p>

				<p v-if="rental.nb_ripped != null && rental.nb_ripped != 0">Compteur arraché {{rental.nb_ripped}} fois pendant {{rental.ripped_time}}s</p>
			</div>
			<div v-if="isExternal">
				<p><b>Durée d'utilisation</b> : {{parseFloat((rental.time_use/360).toFixed(0))/10 + " heures"}}</p>				
				<div v-if="rental.unit_title_label != null">				
					<p><b>Cumul d'activité brut :</b> {{rental.cumul_terrain}} unit</p>
				</div>
				<p v-if="rental.time_use != 0 && rental.unit_title != 4 && rental.cumul_terrain_converted != 0">
					<b>Vitesse moyenne :</b> {{parseFloat(((rental.cumul_terrain_converted/rental.time_use)*360000).toFixed(0))/100}}  {{rental.unit_title_label}}/h
				</p>
				<p v-if="rental.time_use != 0 && rental.unit_title != 4 && rental.cumul_terrain_converted == 0 && rental.cumul_terrain != 0">
					<b>Vitesse moyenne :</b> {{parseFloat(((rental.cumul_terrain/rental.time_use)*3600000).toFixed(0))/100}}  u/h
				</p>
				<p v-if="rental.time_use != 0 && rental.unit_title == 4 && rental.cumul_terrain != 0">
					<b>Vitesse moyenne :</b> {{parseFloat(((rental.cumul_terrain/rental.time_use)*3600000).toFixed(0))/100}} u/h
				</p>
				<b-button v-if="(typeof rental.geolocation_points !== 'undefined') && rental.geolocation_points.length > 0" class="ml-2" size="sm" variant="info" @click="map1_modal_open" :disabled='rental.geolocation_points=="None"'>
					<i class="ti-map-alt"></i>
					AFficher Localisation
				</b-button>
				<!--<b-button  v-if="rental.geolocation_type && (mobile||mobile_version)" class="ml-2" size="sm" variant="info" @click="go_to_location" :disabled='rental.geolocation_type=="None"'>
					<i class="ti-map-alt"></i>
					Itinéraire
				</b-button>-->
				<b-button v-if="rental.geolocation_type && (mobile||mobile_version)" class="ml-2" size="sm" variant="info" @click="go_to_location" :disabled='rental.geolocation_type=="None"' :href="'https://maps.google.com/maps?daddr='+rental.latitude+','+rental.longitude+'&ll='" target="_blank" rel="noreferrer noopener">
					<i class="ti-map-alt"></i>
					Itinéraire
				</b-button>
			</div>
			<b-alert variant="danger" :show="isServerError">Une erreur inattendue est survenue. Si elle persiste, veuillez contacter Kemtag.</b-alert>
			
			<template v-slot:modal-footer v-if="!rental.readOnly">
					<b-button size="sm" variant="danger" @click="onDelete" v-if="!isClotured && !isDeleteBusy" :disabled="isRefreshBusy">Supprimer</b-button>
					<b-button  size="sm" variant="danger" disabled v-if="isDeleteBusy"><b-spinner small></b-spinner> Suppression...</b-button>
					<div class="flex-grow-1 d-flex justify-content-end" v-if="isDefault || isREAL || isValid">
						<b-button v-if="rental.start_val || rental.end_val" size="sm" @click="onEditReal" :disabled="(isRefreshBusy || isDeleteBusy)">Editer</b-button>
						<b-button v-else size="sm" @click="onEdit" :disabled="(isRefreshBusy || isDeleteBusy)">Editer</b-button>
						<div>
							<span id="validation-btn" class="d-inline-block" tabindex="1" v-if="!isValid && !isREAL">
								<b-button size="sm" variant="info" @click="onValidate" class="ml-4" :disabled="isRefreshBusy || isDeleteBusy ">Valider</b-button>
							</span>
						</div>
						<div>
							<span id="cloturate-btn" class="d-inline-block" tabindex="0">
								<b-button size="sm" variant="primary" @click="onCloturate" class="ml-4" :disabled="isRefreshBusy || isDeleteBusy || isInFuture">Cloturer</b-button>
							</span>
							<b-tooltip v-if="isInFuture" target="cloturate-btn">Cloture d'un élément dans le futur impossible</b-tooltip>
						</div>
					</div>
					<b-button size="sm" variant="info" v-if="isClotured && !isDisCloturedateBusy" @click="onDisCloturedate">Réouvrir</b-button>

					<b-button  size="sm" variant="primary" disabled v-if="isDisCloturedateBusy"><b-spinner small></b-spinner> Réouverture...</b-button>
			</template>
		</b-modal>
		<calendar-cloturate @onCloturateSuccess="onCloturateSuccess" ref="modalCloturate"/>
		<calendar-real-edit ref="modalRealEdit" @success="onEditSuccess"/>
		<calendar-edit ref="modalEdit" @success="onEditSuccess"/>
		
	<b-modal 
		id="modal-adh-info" 
		ref="adhInfo"
		title="Informations de l'adhérent" 
		centered>
		<adherent-info :adh_id="rental.adherent_id" :adh_sms="rental.sms"/>
    </b-modal>

	<b-modal ref="map1_popup" hide-footer centered title=" Positions de l'activité"  v-bind:size="(this.mobile ? '' : 'xl')" >
		<v-map1 
			:location_info="rental"
			@map-done = "close_map1_modal"
		>
		</v-map1>
	</b-modal>
		
	</div>
</template>

<script>
	
	import CalendarEdit from './CalendarEdit.vue';
	import CalendarRealEdit from './CalendarRealEdit.vue';
	import CalendarCloturate from './CalendarCloturate.vue';
	import AdherentInfo from '../AdherentInfo.vue';
	import mMap1 from "../../components/Map/Map1"
	import moment from 'moment'
	//import axios from 'axios';
	//add
	import axios from "axios/index";
	import api from "../../config/_api";
	import Calendar from './Calendar.vue';

	export default {
		name: "CalendarInfo",
		components: { 
			CalendarCloturate, 
			CalendarEdit, 
			CalendarRealEdit,
			Calendar,//add
			AdherentInfo,
			'v-map1': mMap1,
			
		},
		
		props: ['systemId'],
		
		data : ()  => ({
			isDeleteBusy: false,
			isDisCloturedateBusy: false,
			isRefreshBusy: false,
			isServerError: false,
			rental : {
				title: null,
				start: new Date(),
				end: new Date(),
				time_use : 0,
				class: 'default',
				status: 0,
				geolocation_points : []
				/*test barycentre
				geolocation_points: [{
					points: []
				}]*/
			},
			badgeLabel: null,
			isExternal: false,
			isDefault: false,
			isValid: false,
			isClotured: false,
			isInFuture : false,
			mobile: false,
			mobile_version : false,
			window: {
				width: 0,
				height: 0
			},
			durationMax : 0,
		}),
		watch: {
			rental: {
				handler: function(val) {
					this.isExternal = false;
					this.isDefault = false;
					this.isValid = false;
					this.isClotured = false;
					this.isREAL = false;
					switch (this.rental.class) {
						case 'default':
							this.badgeLabel = 'Réservation';
							this.isDefault = true;
							break;
						case 'reel':
							this.badgeLabel = 'Chantier déclaré';
							this.isREAL = true;
							break;
						case 'unknown_user':
							this.badgeLabel = 'Chantier déclaré';
							this.isREAL = true;
							break;
						case 'valid':
							this.badgeLabel = 'Chantier validé';
							this.isValid = true;
							break;
						case 'clotured':
							this.badgeLabel = 'Cloturé';
							this.isClotured = true;
							break;
						case 'external':
							this.badgeLabel = 'Données terrain';
							this.isExternal = true;
							break;
					}
					var now = new Date();
					if((this.rental.end>now) || (this.rental.start>now)){
						this.isInFuture = true;
					}
					else{
						this.isInFuture = false;
					}
				},
				deep: true
			},
			'systemId': function (newVal, oldVal) {
				this.$store.dispatch('rentals/setSystemId', {'system_id' : newVal});
				this.load(this.systemId, this.currentStartDate, this.currentEndDate);
			}

		},
		created() {
			this.$store.dispatch('rentals/setSystemId', {'system_id' : this.systemId});//add


            window.addEventListener('resize', this.handleResize);
            this.mobile_version = window.location.hash.includes("m.calendar");
			this.handleResize();
			
		},
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
		},
		
		methods: {
			show (event,rental_max_lenght) {
				this.isDeleteBusy = false;
				this.isDisCloturedateBusy = false;
				this.isRefreshBusy = false;
				this.isServerError = false;
				if((typeof event.geolocation_points == 'undefined') || event.geolocation_points == null){
					event.geolocation_points = [];
				}
				this.rental = event;
				
				this.durationMax = rental_max_lenght;

				if(this.durationMax % 86400 === 0){
                    this.maxRentalTimeDiplay = this.durationMax/86400 + " jours";
                }
                else if (this.durationMax % 3600 === 0 && this.durationMax % 86400 !== 0) {
                    this.maxRentalTimeDiplay = this.durationMax/3600 + " heures";
                }
                else if (this.durationMax % 60 === 0 && this.durationMax % 3600 !== 0 && this.durationMax % 86400 !== 0) {
                    this.maxRentalTimeDiplay = this.durationMax/60 + " minutes";
                }
                else {
                    this.maxRentalTimeDiplay = this.durationMax + " secondes";
                }

				this.$bvModal.show("modal-info");
			},
			clean () {
				this.rental = {
					title: null,
					start: new Date(),
					end: new Date(),
					time_use : 0,
					class: 'default',
				}
			},
			onRefresh () {
				this.isRefreshBusy = true;
				this.$store.dispatch('rentals/refresh', {
					'id': this.rental.id,
				}).then(function(rental){
					this.rental = rental;
					this.isRefreshBusy = false;
					this.isServerError = false;
					var now = new Date();
					this.rental.start = new Date(this.rental.start);
					this.rental.end = new Date(this.rental.end);
					if((this.rental.end>now) || (this.rental.start>now)){
						this.isInFuture = true;
					}
					else{
						this.isInFuture = false;
					}
				}.bind(this)).catch((error) => {
					this.isServerError = true;
					this.isRefreshBusy = false;
				})
			},
			onShowAdh () {

				this.$refs.adhInfo.show(this.rental);
			},
			onEdit () {
				this.$refs.modalEdit.show(this.rental,this.durationMax);
				this.$bvModal.hide('modal-info');
			},
			onEditReal () {
				this.$refs.modalRealEdit.show(this.rental,this.durationMax);
				this.$bvModal.hide('modal-info');
			},
			onEditSuccess(e) {
				this.$emit('edit-event', e)
			},
			onValidate () {
				this.isBusy = true;
				this.$store.dispatch('rentals/validate', {
					id: this.rental.id,
					cumul_valid: this.cumulValid
				}).then(rental => {
					this.rental = rental;
					this.isBusy = false;
					this.$bvModal.hide('modal-info');
					this.isServerError = false;
				}).catch((error) => {
					this.isServerError = true
					this.isBusy = false
				})

			},
			onDisCloturedate () {
				this.isDisCloturedateBusy = true;
				this.$store.dispatch('rentals/disconfirm', { 
					'id': this.rental.id,
				}).then(rental => {
					this.rental = rental;
					this.isDisCloturedateBusy = false;
					this.isServerError = false;
					this.isValid = true;
					this.isClotured = false;
				}).catch((error) => {
					this.isServerError = true;
					this.isDisCloturedateBusy = false;
				})
			},
			onCloturate () {
				this.$refs.modalCloturate.show(this.rental.id, this.rental.cumul_terrain_converted, this.rental.unit_title_label);
			},
			onCloturateSuccess (r) {
				this.$bvModal.hide('modal-cloturate');
				this.$bvModal.hide('modal-info');
				this.isDefault = false;
				this.isValid = false;
				this.isClotured = true;
			},
			onDelete () {
				this.$bvModal.msgBoxConfirm('Êtes-vous certain de vouloir supprimer cette réservation ?', {
					title: 'Suppression',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Confirmer',
					cancelTitle: 'Annuler',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if(value) {
						this.isDeleteBusy = true;
						this.$store.dispatch('rentals/delete', { 
							'id': this.rental.id,
						}).then(x => { 
							this.isDeleteBusy = false;
							this.isServerError = false;
							this.$bvModal.hide('modal-info')
						}).catch((error) => {
							this.isServerError = true;
							this.isDeleteBusy = false;
						})
					}
				})
			},
			deleteCurrentRental () {
				this.$bvModal.msgBoxConfirm('Êtes-vous certain de vouloir supprimer la réservation en cours ?', {
					title: 'Suppression réservation en cours',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Confirmer',
					cancelTitle: 'Annuler',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if(value) {
						this.isDeleteBusy = true;
						this.$store.dispatch('rentals/deleteCurrent', { 
							'sysid': this.systemId,
							//'startDate': (this.rental.start | moment('YYYY-MM-DD HH:mm:ss')),
						}).then(x => { 
							this.isDeleteBusy = false;
							this.isServerError = false;
							this.$bvModal.hide('modal-info')
						}).catch((error) => {
							this.isServerError = true;
							this.isDeleteBusy = false;
						})
					}
				})
			},
			stopCurrentRental () {
				this.$bvModal.msgBoxConfirm('Êtes-vous certain de vouloir mettre fin à la réservation en cours?', {
					title: 'Cloture réservation en cours',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Confirmer',
					cancelTitle: 'Annuler',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if(value) {
						this.isDeleteBusy = true;
						this.$store.dispatch('rentals/stopCurrent', { 
							'sysid': this.systemId,
							//'startDate': moment(this.rental.start).format('YYYY-MM-DD HH:mm:ss'),
						}).then(x => {
							this.isDeleteBusy = false;
							this.isServerError = false;
							this.$bvModal.hide('modal-info')
							//TODO display a message telling that new rental will be created within 2 minutes
						}).catch((error) => {
							this.isServerError = true;
							this.isDeleteBusy = false;
						})
					}
				})
			},
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.mobile=(this.window.width<1080)? true : false ;
            },
			map1_modal_open(rental) {
		
				//this.rental.geolocation_points.latitude = parseFloat(this.rental.geolocation_points.latitude);
				//this.rental.geolocation_points.longitude = parseFloat(this.rental.geolocation_points.longitude);
				
                //Passer le système selectionné à l'enfant
				this.$refs.map1_popup.show()
				
			},
			go_to_location(rental) {
				this.rental.latitude = parseFloat(this.rental.latitude);
				this.rental.longitude = parseFloat(this.rental.longitude);
                //Passer le système selectionné à l'enfant
				window.open("https://maps.google.com/maps?daddr="+this.rental.latitude+","+this.rental.longitude+"&ll=");
            },
			close_map1_modal() {
                this.$refs.map1_popup.hide();
            },
		}
	}
	</script>
